import api from "./api.service";

export interface Expediente2 {
  id: number;
  expediente: string;
  nro_proceso?: string;
  ruc?: string;
  consorcio?: string;
  html_encriptado?: string;
  fecha_expediente?: string;
}

export const getExpedientes2 = async (anio?: string) => {
  const resp = await api.get("/expedientes2", { params: anio ? { anio } : undefined });
  return resp.data;
};

export const getHtmlExpediente2 = async (id: number) => {
  const resp = await api.get(`/expedientes2/${id}/html`);
  return resp.data;
};
